export default {
  LOGIN: "auth/login/",
  REGISTER: "developers/register/",
  sendResetPasswordLink: "auth/send-reset-password/otp/",
  VERIFY_OTP: "auth/verify-reset-password-otp/",
  setPassword: "auth/set-new-password/",
  LOGOUT: "auth/logout/",
  user: `auth/user`,
  VERIFY: `auth/login/otp/`,
  sendOtp: `auth/sendOtp`,
  verifyOtp: `auth/verify`,
};
